import Header from './components/Header';
import Hero from './components/Hero';
import Updates from './components/Updates';
import About from './components/About';
import TopicIndex from './components/TopicIndex';
import AppPromo from './components/AppPromo';
import Ranking from './components/Ranking';
import MediaSection from './components/MediaSection';
import InfoCards from './components/InfoCards';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Updates />
        <About />
        <TopicIndex />
        <AppPromo />
        <Ranking />
        <MediaSection />
        <InfoCards />
        <Topics />
        <Carousel />
        <Contact />
        <FAQ />
        <Features />
        <Comments />
      </main>
      <Footer />
    </>
  );
}